// 이미지 컴포넌트

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역
import React, { // 리액트 베이스
  useEffect, // 상태 변경 이벤트 헨들러
  useState, // 내부 상태 관리 훅
  useRef, // 객체 참조자
  forwardRef,
  Fragment, // 재사용 가능한 라이브러리 컴포넌트에서, 자식 중 하나에 ref를 전달
  useCallback, // 상태 변경시까지 함수 재사용 장치 // 재사용 가능한 라이브러리 컴포넌트에서, 자식 중 하나에 ref를 전달
} from 'react';
import M from 'src/com/keymansco/chihuahuaone/helper/mainHelper'; // 메인 헬퍼
import atom from 'src/com/keymansco/chihuahuaone/atom/index'; // 원자 컴포넌트
import molecule from 'src/com/keymansco/chihuahuaone/molecule/index'; // 분자 컴포넌트
import organism from 'src/com/keymansco/chihuahuaone/organism/index'; // 업무 컴포넌트
import template from 'src/com/keymansco/chihuahuaone/template/index'; // 템플릿 컴포넌트
import page from 'src/com/keymansco/chihuahuaone/page/index'; // 페이지 컴포넌트

// 동적 영역
import ImageModel from './ImageModel'; // 모델
import {
  Image as ImageOfNativeBase, // 이미지
} from 'native-base';

// =================================================================================================
// 상수
// =================================================================================================

// =================================================================================================
// 컴포넌트 정의
// =================================================================================================
const Image = forwardRef((props, ref) => {
  // 내부 상태 [컴포넌트 자체 뷰 갱신 전용. private.]
  const [isLoading, setIsLoading] = useState(true);
  const [isUseLoading, setIsUseLoading] = useState(
    M.device.getOS() == 'web' // 플랫폼 OS 겟 {ios, android, web}
      ? false
      : true,
  ); // 로딩중 사용 여부

  // 외부 상태 [외부 개방용. public.]
  let P = ImageModel; // P 자동완성용
  P = props; // 속성. 읽기전용.

  // 참조 변수
  // const domRef = useRef(null);

  // 상수

  // =================================================================================================
  // 컨테이너 컴포넌트 이벤트 핸들러
  // =================================================================================================
  // 컴포넌트 미운트 시 [componentDidMount, componentDidUpdate] [인자값 변경시 동작] [빈 배열 적용시 최초 마운트 때 한번 동작]
  useEffect(() => {
    // M.log.info('Image');

    // 컴포넌트 언마운트 시(componentWillUnmount)
    return () => {};
  }, []);

  // =================================================================================================
  // 컴포넌트 함수 정의
  // =================================================================================================

  // =================================================================================================
  // 그리기
  // =================================================================================================
  // 렌더링(render)
  return (
    <atom.layout.ZStack // Z축 쌓기
      type={'center'} // 타입 {undefined: 미정의, centerTop: 중앙상단+풀, centerFull: 중앙+풀, center: 중앙}
      height={P.height ? P.height : M.theme.sizes.full} // height [h]
      width={
        M.device.getOS() == 'web' // 플랫폼 OS 겟 {ios, android, web}
          ? P.width
            ? P.width
            : P.type == 'basic'
            ? M.theme.sizes[20]
            : undefined
          : undefined
      } // width [w] [nPx, fit-content, ...] [sizes]
    >
      <ImageOfNativeBase // 이미지
        alt={'image'} // [오프라인 상태에서 표시됨. 접근성 기능으로 읽어주기 수행시 활용됨.]
        // {...(P.type == 'basic' ? M.style.layout.alignSelfCenter : {})} // align-self
        height={isLoading ? M.theme.sizes['0.5'] : P.type == 'basic' ? M.theme.sizes[20] : undefined} // height [h]
        // margin={P.type == 'basic' ? M.theme.space[0.5] : undefined} // margin [m]
        size={P.height ? undefined : M.theme.sizes.full} // 크기 (단위: 밀도독립화소=DIP=DP=모든장치에서 동일 크기로 보임) ResponsiveValue<number | "px" | "0" | "full" | "sm" | "6" | "2xs" | "8" | "xs" | "12" | "md" | "16" | "xl" | "24" | "32" | "2" | "0.5" | "4" | "3" | "lg" | "1" | "2xl" | "10" | "20" | "64" | "container" | ... 28 more ... | (string & {})>
        width={P.type == 'basic' ? M.theme.sizes[20] : undefined} // width [w] [nPx, fit-content, ...]
        resizeMode={'cover'} // {center: 중앙. 기본., cover: 공간 안비게. 비율 유지., contain: 그림 안잘리게. 비율 유지., stretch: 채우기. 비율 변경., repeat: 반복}
        onLoadStart={() => {
          setIsLoading(true);
        }}
        onLoadEnd={() => {
          setIsLoading(false);
        }}
        {...P}
        ref={ref}
        style={{
          // 인라인 스타일 [스타일 분리시, 모양새 추정에 불리.]
          ...P.style,
        }}
      >
        {P.children}
      </ImageOfNativeBase>
      {isUseLoading && isLoading && (
        <atom.layout.VStack // 행 쌓기
          type={'centerFull'} // 타입 {undefined: 미정의, bgBasicCenterFull: 배경+중앙+풀, centerFull: 중앙+풀, bottomCenter: 하단+중앙}
          padding={undefined} // padding [p] [space]
        >
          <atom.feedback.Spinner // 회전자
          />
        </atom.layout.VStack>
      )}
    </atom.layout.ZStack>
  );
});

// =================================================================================================
// 내보내기
// =================================================================================================
export default Image;
